export const environment = {
  
  production: false,
  environment: 'dev',
  mobileViewBreakPoint: 850,
  backendService: {
    url: 'https://pocgenai.orona-group.com/api/v1/',
    clientId: 'b526c050-896f-4171-a743-20e17fb63d6b',
    authority: 'https://login.microsoftonline.com/b85453c0-e185-41be-92e3-3fc3d0a0b1ed',
    redirectUri:   'https://pocgenai.orona-group.com',
    logoutRedirectUri:  'https://pocgenai.orona-group.com',
    scopes: [
      'openid',
      'profile',
      'email',
      'api://316ab464-ba98-4b23-b0eb-a529fb6a206f/User.Write'
    ]
  }
};
